import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Label from '../../../../components/svg/Label';
import { getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import FieldWrapper from './FieldWrapper';
import LocationTextModal from '../../Editors/LocationTextModal';
import LocationMapModal from '../../Editors/LocationMapModal';
import * as actions from './../../../actions';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

//@ts-ignore - FIX
@connect(
  (state: TypeMePlease) => ({
    sasToken: state.shared.sasToken,
    fileUrls: state.formeditor.fileUrls
  }),
  actions
)
export default class LocationTextField extends PureComponent<LocationTextFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.state = {
      modalOpen: false
    };
  }

  mouseDown() {
    this.setState({ modalOpen: !this.state.modalOpen });
  }

  handleModalClose() {
    this.setState({ modalOpen: false });
  }

  render() {
    let printFriendlyCoordinates = null;
    if (this.props.value) {
      const properties = JSON.parse(this.props.value);
      if (properties.Latitude != null && properties.Longitude != null) {
        printFriendlyCoordinates = `${properties.Latitude} , ${properties.Longitude}`;
      } else if (properties.Error) {
        printFriendlyCoordinates = properties.Error;
      }
    } else {
      printFriendlyCoordinates = '';
    }

    let locationModal = null;
    if (this.state.modalOpen) {
      if (this.props.requireMapImage) {
        const mapImageWidth = this.props.backgroundCropDimensions.w;
        const mapImageHeight = this.props.backgroundCropDimensions.h;
        locationModal = (
          <LocationMapModal
            name={this.props.name}
            value={this.props.value}
            valueUpdated={this.props.valueUpdated}
            sasToken={this.props.sasToken}
            onClose={this.handleModalClose}
            w={mapImageWidth}
            h={mapImageHeight}
            formId={this.props.formId}
            fontSize={this.props.fieldFontSize}
            color={this.props.fieldColor}
            fontName={this.props.fieldFontName}
            dateStamp={this.props.dateStamp}
            fieldId={this.props.fieldId}
            rowNumber={this.props.rowNumber}
            fileUrls={this.props.fileUrls}
            getSharedFormImageUrl={this.props.getSharedFormImageUrl}
          />
        );
      } else {
        locationModal = (
          <LocationTextModal name={this.props.name} value={this.props.value} valueUpdated={this.props.valueUpdated} onClose={this.handleModalClose} />
        );
      }
    }

    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        <Label
          text={printFriendlyCoordinates}
          fontName={this.props.fontName}
          fontSize={this.props.fontSize}
          width={this.props.w}
          align={this.props.align}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
        />
        {locationModal}
      </FieldWrapper>
    );
  }
}

export interface LocationTextFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id: string;
  fieldId: string;
  x: number;
  y: number;
  w: number;
  h: number;
  align: string;
  foregroundColor: TypeMePlease;
  backgroundColor: TypeMePlease;
  fontName: string;
  fontSize: number;
  padding: number;
  editable: boolean;
  name: string;
  value: string;
  sasToken?: TypeMePlease;
  requireMapImage: boolean;
  backgroundCropDimensions: TypeMePlease;
  formId: string;
  dateStamp: boolean;
  rowNumber: number;
  fileUrls?: TypeMePlease;
  getSharedFormImageUrl?: AnyFunc;
  fieldColor: string;
  fieldFontSize: number;
  fieldFontName: string;
}
